






import Vue from 'vue';

import ResetPassword from '@/web/components/signup/ResetPassword.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'StudioResetPassword',
  components: {
    ResetPassword,
  },
});
